import invariant from 'invariant';
import PropTypes from 'prop-types';
import React, { Children } from 'react';
import { css } from 'styled-components';

import { breakpoint } from '../grid';
import { cloneElementWithStyles } from '../utils';
import Button from './Button';

const ensureTwoChildren = children => {
    const count = children.length;

    invariant(
        count === 2,
        'Exactly two `Button` elements must be provided to `ButtonGroup`, ' +
        `but ${count} ${count > 1 ? 'were' : 'was'} received.`
    );
};

const firstButtonCSS = css`
    ${breakpoint('xsmall', { down: true })} {
        box-sizing: border-box;
        width: 100%;
    }
`;

const secondButtonCSS = css`
    ${breakpoint('xsmall', { down: true })} {
        box-sizing: border-box;
        margin-top: ${p => (p.style === Button.STYLE.LINK ? '0' : '12px')} !important;
        width: 100%;
    }

    ${breakpoint.small} {
        margin-left: ${p => (p.style === Button.STYLE.LINK ? '0' : '22px')} !important;
    }
`;

const ButtonGroup = ({ children, ...props }) => {
    const buttons = Children.toArray(children);

    ensureTwoChildren(buttons);

    return (
        <div {...props}>
            {cloneElementWithStyles(buttons[0], firstButtonCSS)}
            {cloneElementWithStyles(buttons[1], secondButtonCSS)}
        </div>
    );
};

ButtonGroup.propTypes = {
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default ButtonGroup;
